module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "note-editor"
    }
  }, [_c('textarea', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.activeNote.text
    },
    on: {
      "input": _vm.updateNote
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a36c78c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 119
// module chunks = 2